$(".site-header__search-toggle").click(function () {
  $(".search-bar-wrap").addClass("active");
});

$(document).mouseup(function (e) {
  var container = $(".search-bar-wrap");
  if (!container.is(e.target) && container.has(e.target).length === 0) {
    container.removeClass("active");
  }
});

$(document).ready(function () {
  $(".hover-carousel").owlCarousel({
    loop: true,
    margin: 10,
    responsiveClass: true,
    responsive: {
      0: {
        items: 1,
        nav: true,
      },
      600: {
        items: 2,
        nav: true,
      },
      1000: {
        items: 3,
        nav: true,
        loop: true,
      },
    },
  });


   $(".style-carousel").owlCarousel({
     loop: true,
     autoplay: true,
     responsive: {
       0: {
         items: 2,
         nav: true,
       },
     },
   });


  // $(".thumb-carousel").owlCarousel({

  //   autoWidth: false,
  //   items: 3,
  //   slideBy: 1,
  //   nav:true,
  //   mouseDrag  : false,
  //   responsive: {
  //     600: {
  //       autoWidth: false,
  //       nav: false,

  //     },
  //     1000: {
  //       autoWidth: false,
  //       nav: true,
  //       slideBy: 1,
  //       navText: [
  //         "<img src='https://cdn.shopify.com/s/files/1/0406/3376/1952/files/Chevron_Left.png?v=1632433794'>",
  //         "<img src='https://cdn.shopify.com/s/files/1/0406/3376/1952/files/Chevron_Right.png?v=1632433794'>",
  //       ],
  //     },
  //   },
  // });


  $(".thumb-carouselsadasd").owlCarousel({
    loop: false,
    autoWidth: false,
    items: 3,
    dots: true,
    slideBy: 1,
    responsive: {
      420: {
        items: 3,
        autoWidth: false,
        nav: false,
      },
      600: {
        items: 3,
        autoWidth: false,
        nav: false,
      },
      1000: {
        items: 3,
        autoWidth: false,
        nav: true,
        slideBy: 1,
        navText: [
          "<img src='https://cdn.shopify.com/s/files/1/0406/3376/1952/files/Chevron_Left.png?v=1632433794'>",
          "<img src='https://cdn.shopify.com/s/files/1/0406/3376/1952/files/Chevron_Right.png?v=1632433794'>",
        ],
      },
    },
  });



  $("#shopify-section-16301129092e69ce19 .main-img:nth-child(1)")
    .siblings()
    .hover(function () {
      $(
        "#shopify-section-16301129092e69ce19 .main-img:nth-child(1) img"
      ).toggleClass("opacity-none");
    });
});

$(".banner").owlCarousel({
  loop: true,
  margin: 10,
  // nav: true,
  // navText: [
  //   "<img src='https://cdn.shopify.com/s/files/1/0406/3376/1952/files/back.png?v=1635300701'> ",
  //   " <img src='https://cdn.shopify.com/s/files/1/0406/3376/1952/files/Group.png?v=1635300701'> ",
  // ],
  dots: true,
  smartSpeed: 300,
  slideSpeed: 1000,
  autoplay: true,
  autoplayTimeout: 2000,
  responsive: {
    0: {
      items: 1,
    },
    767: {
      items: 2,
      autoplay: true,
    },
  },
});

$(".testi-carousel").owlCarousel({
  loop: true,
  margin: 0,
  nav: false,
  dots: true,
  smartSpeed: 300,
  slideSpeed: 1000,
  autoplay: false,
  center: true,
  autoplayTimeout: 5000,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 1,
      nav: false,
    },
    1024: {
      items: 1,
      nav: false,
      loop: true,
    },

    1440: {
      items: 3,
      nav: false,
      loop: true,
    },
  },
});

$(".testimonial-carousel").owlCarousel({
  loop: true,
  margin: 0,
  // nav: true,
  // navText: [
  //   "<img src='https://cdn.shopify.com/s/files/1/0406/3376/1952/files/Left_Arrow_2.png?v=1637799642'> ",
  //   " <img src='https://cdn.shopify.com/s/files/1/0406/3376/1952/files/RightArrow_2.png?v=1637799642'> ",
  // ],
  dots: true,
  smartSpeed: 300,
  slideSpeed: 1000,
  autoplay: true,
  autoplayTimeout: 5000,
  autoplayHoverPause: true,
  responsive: {
    0: {
      items: 1,
    },
    1000: {
      items: 1,
    },
  },
});



$(".main-carousel").owlCarousel({
  loop: true,
  margin: 0,
  // nav: true,
  // navText: [
  //   "<img src='https://cdn.shopify.com/s/files/1/0406/3376/1952/files/Left_Arrow_2.png?v=1637799642'> ",
  //   " <img src='https://cdn.shopify.com/s/files/1/0406/3376/1952/files/RightArrow_2.png?v=1637799642'> ",
  // ],
  dots: true,
  smartSpeed: 300,
  slideSpeed: 1000,
  autoplay: true,
  responsive: {
    320: {
      items: 1,
      // nav: true,
      // navText: [
      //   "<img src='https://cdn.shopify.com/s/files/1/0406/3376/1952/files/back.png?v=1635300701'> ",
      //   " <img src='https://cdn.shopify.com/s/files/1/0406/3376/1952/files/Group.png?v=1635300701'> ",
      // ],
    },
    1024: {
      items: 1,
      // nav: true,
      // navText: [
      //   "<img src='https://cdn.shopify.com/s/files/1/0406/3376/1952/files/Group_12.png?v=1635362384'> ",
      //   " <img src='https://cdn.shopify.com/s/files/1/0406/3376/1952/files/Group_13.png?v=1635362399'> ",
      // ],
    },
  },
});

$(".pro-carousel").owlCarousel({
  loop: true,
  margin: 10,
  dots: true,
  slideSpeed: 1000,
  autoplay: true,
  // nav: true,
  // navText: [
  //   "<img src='https://cdn.shopify.com/s/files/1/0406/3376/1952/files/back.png?v=1635300701'> ",
  //   " <img src='https://cdn.shopify.com/s/files/1/0406/3376/1952/files/Group.png?v=1635300701'> ",
  // ],
  autoplayTimeout: 5000,
  responsive: {
    100: {
      items: 1,
    },
    767: {
      items: 2,
    },
    1440: {
      items: 2,
    },
    1600: {
      items: 3,
    },
  },
});

// document.addEventListener('contextmenu', function(e) {
//   e.preventDefault();
// });

// document.onkeydown = function(e) {
//   if(event.keyCode == 123) {
//      return false;
//   }
//   if(e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
//      return false;
//   }
//   if(e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
//      return false;
//   }
//   if(e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
//      return false;
//   }
//   if(e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
//      return false;
//   }

// }

let tittle1 = document.getElementById("product-json1");
let tittle2 = document.getElementById("product-json2");
let tittle3 = document.getElementById("product-json3");

let iconMenu = document.getElementById("anim_home");

let animationMenu = bodymovin.loadAnimation({
  container: iconMenu,
  renderer: "svg",
  loop: false,
  autoplay: false,
  path: "https://cdn.shopify.com/s/files/1/0406/3376/1952/files/04.json?v=1632185949",
});

var directionMenu = 1;

tittle1.addEventListener("mouseenter", (e) => {
  animationMenu.setDirection(directionMenu);
  animationMenu.play();
});

tittle1.addEventListener("mouseleave", (e) => {
  animationMenu.setDirection(-directionMenu);
  animationMenu.play();
});

tittle2.addEventListener("mouseenter", (e) => {
  animationMenu.setDirection(directionMenu);
  animationMenu.play();
});

tittle2.addEventListener("mouseleave", (e) => {
  animationMenu.setDirection(-directionMenu);
  animationMenu.play();
});

tittle3.addEventListener("mouseenter", (e) => {
  animationMenu.setDirection(directionMenu);
  animationMenu.play();
});

tittle3.addEventListener("mouseleave", (e) => {
  animationMenu.setDirection(-directionMenu);
  animationMenu.play();
});

/////////////////////hamberger/////////////////////////





$(window).scroll(function(){
  if ($(window).scrollTop() > 120) {
      $('.global-header').addClass('fixed');
  } else {
      $('.global-header').removeClass('fixed');

  }
});




// $(window).scroll(function(){
//   var sticky = $('.global-header'),
//       scroll = $(window).scrollTop();

//   if (scroll >= 100) sticky.addClass('fixed');
//   else sticky.removeClass('fixed');
// });

// window.onscroll = function() {myFunction()};

// var header = document.getElementById("home-page-header");
// var sticky = header.offsetTop;

// function myFunction() {
//   if (window.pageYOffset > sticky) {
//     header.classList.add("fixed");
//   } else {
//     header.classList.remove("fixed");
//   }
// }
